import { render, staticRenderFns } from "./GamesSettingDialog.vue?vue&type=template&id=ec3f937c&scoped=true"
import script from "./GamesSettingDialog.vue?vue&type=script&lang=js"
export * from "./GamesSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./GamesSettingDialog.vue?vue&type=style&index=0&id=ec3f937c&prod&lang=scss&scoped=true"
import style1 from "./GamesSettingDialog.vue?vue&type=style&index=1&id=ec3f937c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3f937c",
  null
  
)

export default component.exports